export const CLEAR_FORM_DATA = 'CLEAR_FORM_DATA';

export const clearFormData = () => dispatch =>
  dispatch({
    type: CLEAR_FORM_DATA,
  });
